
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ApprovalClaimsService, ApprovalInsuranceService } from 'app/shared/services';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { BaseComponent } from 'app/shared/infrastructure/base.component'; // leaf import - do not revert to the barrel (app/shared/infrastructure), breaks ng test (circular dependency)

@Component({
    selector: 'post-e-approval-cmp',
    templateUrl: './post-e-approval.html',
})

export class PostEApprovalComponent extends BaseComponent {
    @Input() isResubmission: boolean;
    @ViewChild('attachmentsModal') attachmentsModal: ModalDirective;
    @ViewChild('postEApprovalModal') postEApprovalModal: ModalDirective;
    @Output() onConfirm = new EventEmitter();

    modalTitle: string = '';
    servicesApproval: any[] = [];
    coverageLetterColumns: any[];
    selectedItem: any;
    approvalId: any;

    selectedFile: any;
    selectedDocument: any;
    files: File[] = [];

    form = new FormGroup({
        attachment: new FormControl(''),
    });

    get attachment(): AbstractControl { return this.form.get('attachment') };

    constructor(private _service: ApprovalInsuranceService,
        private approvalClaimsService: ApprovalClaimsService) {
        super();

    }

    ngOnInit() {
        if (this.isResubmission) {
            this.modalTitle = 'Resubmission'
        } else {
            this.modalTitle = 'Post EApproval'
        }
        this.servicesApproval = [];
        this.setCoverageLetterColumns();
    }

    async openEApproval(approvalId) {
        this.get(approvalId);
    }

    setCoverageLetterColumns() {
        this.coverageLetterColumns = [
            { field: 'Title', header: 'Service Name' },
            { field: 'Quantity', header: 'Allowed Times' },
            { field: 'ServicePercentage', header: 'Coverage Percentage' },
            { field: 'ServiceLimit', header: 'Approval Limit' },
            { field: 'ServiceCashLimit', header: 'Max Patient Share' },
            { field: 'ApprovalNo', header: 'Approval Number' },
            { field: 'ToothNumber', header: 'Tooth Number' },
            { field: 'ToothSurfaceTitle', header: 'Tooth Surface' },
            { field: 'DrugIntervalInfo', header: 'Drug Interval' },
            { field: 'ItemUnitTitle', header: 'Unit Title' }
        ];
    }

    selectDocuments(event) {
        if (event?.length > 1) {
            this.showError("Only one file can be selected");
            return;
        }
        this.selectedFile = event.files[0];

        const reader = new FileReader();
        reader.addEventListener('load', () => {
            this.selectedDocument = {
                extension: this.fileInfo(this.selectedFile)?.extention || '',
                attachmentBase64: reader.result,
            };
        }, false);
        reader.readAsDataURL(this.selectedFile);
    }

    clearDocuments() {
        this.selectedFile = null;
    }

    removeDocument() {
        this.selectedFile = null;
        this._service.deleteAttachmentByServiceId(this.selectedItem.Id).subscribe({
            next: () => {
                this.showSuccess("Attachment removed successfully");
            },
            error: (error: any) => {
                this.showError(error);
            }
        });
    }

    disableForm(): boolean {
        return !this.selectedFile;
    }

    uploadAttachment() {
        this.approvalClaimsService.uploadAttachment(this.selectedFile)
            .subscribe({
                next: (data: any) => {
                    const response = JSON.parse(data || '');
                    if (response.Success) {
                        this.attachment.setValue(response.EntityID);
                        this.postAttachment();
                    }
                },
                error: (error: any) => {
                    this.showError(error);
                }
            });
    }


    postAttachment() {
        const data = {
            ApprovalId: this.selectedItem.ApprovalId,
            ServiceId: this.selectedItem.Id,
            Attachment: this.attachment.value,
            AttachmentTitle: this.selectedFile.name
        };
        this.approvalClaimsService.postAttachment(data).
            subscribe((data: any[]) => {
                this.selectedDocument = null;
                this.attachmentsModal.hide();
                this.selectedItem = null;
            },
                error => this.showError(error));
    }

    onSubmit() {
        if (!this.form.valid) {
            this.form.markAllAsTouched();
            return;
        }
        else if (!this.selectedItem && !this.selectedDocument) {
            return;
        }

        if (this.selectedFile)
            this.uploadAttachment();
    }

    onConfirmAction() {
        if (this.isResubmission) {
            this.resubmission();
        } else {
            this.postHPortalApproval(this.approvalId)
        }
    }

    postHPortalApproval(id: number) {
        this.approvalClaimsService.claimApproval(id).
            subscribe((data: any[]) => {
                this.postEApprovalModal.hide();
                this.onConfirm.emit(true);
            },
                error => this.showError(error));
    }

    resubmission() {
        this.approvalClaimsService.resubmission(this.approvalId, this.attachment.value).subscribe({
            next: (response) => {
                if (!response?.IsSuccess) {
                    this.showError(response?.UserMessage || "Error on resubmission, please call adminstrator");
                }
                else {
                    this.showSuccess("Data saved successfully");
                    this.postEApprovalModal.hide();

                }
            },
            error: (e) => {
                this.showError(e);
            }
        });
    }

    onViewAttachment(rowData: any) {
        this.selectedItem = rowData;
        this.form.reset();
        this.selectedFile = null;
        this.files = [];

        this._service.getAttachmentByServiceId(this.selectedItem.Id).subscribe({
            next: (res) => {
                if (res && res.AttachmentId) {
                    const file = new File([""], res.AttachmentTitle, { type: "application/pdf" });
                    this.files = [file];
                }

                this.attachmentsModal.show();
            },
            error: () => {
                this.showError('Failed to load attachment');
                this.attachmentsModal.show();
            }
        });
    }

    get(approvalId) {
        if (!approvalId) {
            return;
        }
        this.approvalId = approvalId;
        this._service.getServicesByApprovalId(approvalId)
            .subscribe({
                next: (response: any[]) => {
                    this.servicesApproval = response;
                    this.postEApprovalModal.show();
                },
                error: (e) => {
                    this.servicesApproval = [];
                    this.showError(e);
                }
            })
    }
}
